export default __webpack_public_path__ + "static/media/logo-small-w.0c4ef264.png";